import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { Breadcrumb } from '../components/Breadcrumb'
import { device } from '../components/Breakpoints'
import { colors } from '../components/Colors'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import AccordionDefault from '../components/Accordion'
import LinkList from '../components/LinkList'
import OutboundLinks from '../components/OutboundLinks'
import ThumbList from '../components/ThumbList'
import VideoSlider from '../components/VideoSlider'

const Container = styled.section`
  width: 100%;
  h2 {
    @media ${device.mobileL} {
      font-size: 22px !important;
    }
  }
  .Verde {
    background: ${colors.verdeGradiente};
    color: #fff;
  }
  .Lilas {
    background: ${colors.lilasGradiente};
    color: #fff;
  }
  .Vermelho {
    background: ${colors.laranjaGradiente};
    color: #fff;
  }
  .componente_2 {
    .inner {
      div {
        width: 49%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      img {
        width: 100%;
      }
    }
  }
  .componente_1,
  .componente_3,
  .componente_4,
  .componente_5,
  .componente_6,
  .componente_7,
  .componente_8 {
    .inner {
      display: block;
      h2 {
        width: 100% !important;
      }
      div {
        width: 100%;
        .resposta {
          color: #4a4a4a !important;
          width: auto;
        }
      }
    }
  }
`

const GroupContent = styled.section`
  padding: 2em 0;
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h3 {
      text-align: left;
    }
  }
  h3 {
    font-size: 1.1em;
  }
  .inner {
    display: flex;
    justify-content: space-between;
    @media ${device.mobileL} {
      flex-wrap: wrap;
      img {
        margin-top: 20px;
      }
    }
  }
`

export const CustomPageTemplate = ({
  title,
  content,
  slug,
  imageGatsby,
  image,
  alturaImagem,
  color,
  area,
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    {
      id: 3,
      link: slug,
      title,
    },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />
        <PageHeader
          title={title}
          content={content}
          imageGatsby={imageGatsby}
          image={image}
          color={color}
          bottom="0"
          height={alturaImagem ? `${alturaImagem}px` : '150px'}
          imgWidth="50%"
          imgInner
          mobileTop="-13%"
          mobileRight="0%"
          overflow="visible"
        />
        {sessoes !== null
          ? sessoes.map(sessao => (
              <GroupContent
                key={sessao.tituloDaSessao}
                className={`${sessao.corDaSessao
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')} componente_${
                  sessao.tipoDeConteudo
                }`}
              >
                <div className="inner center">
                  {(() => {
                    switch (sessao.tipoDeConteudo) {
                      case '1':
                        return (
                          <>
                            <h2>{sessao.tituloDaSessao}</h2>
                            <div
                              dangerouslySetInnerHTML={{ __html: sessao.texto }}
                            />
                          </>
                        )
                      case '2':
                        return (
                          <>
                            <h2>{sessao.tituloDaSessao}</h2>
                            <div
                              dangerouslySetInnerHTML={{ __html: sessao.texto }}
                            />
                            {sessao.imagemDaSessao.localFile ? (
                              <div>
                                <Img
                                  fluid={
                                    sessao.cimagemDaSessao.localFile
                                      .childImageSharp.fluid
                                  }
                                  alt={sessao.imagemDaSessao.altText}
                                />
                              </div>
                            ) : (
                              <div>
                                <img
                                  src={sessao.imagemDaSessao.sourceUrl}
                                  alt={sessao.imagemDaSessao.altText}
                                />
                              </div>
                            )}
                          </>
                        )
                      case '3':
                        return (
                          <>
                            <h2>{sessao.tituloDaSessao}</h2>
                            <AccordionDefault data={sessao.acordeao} />
                          </>
                        )
                      case '4':
                        return (
                          <>
                            <h2>{sessao.tituloDaSessao}</h2>
                            <LinkList links={sessao.links} />
                          </>
                        )
                      case '5':
                        return (
                          <>
                            <h2>{sessao.tituloDaSessao}</h2>
                            <OutboundLinks links={sessao.linksExternos} />
                          </>
                        )
                      case '6':
                        return (
                          <>
                            <h2>{sessao.tituloDaSessao}</h2>
                            <ThumbList items={sessao.thumbList} />
                          </>
                        )
                      case '7':
                        return (
                          <>
                            <h2>{sessao.tituloDaSessao}</h2>
                            {sessao.imagemDaSessao.localFile ? (
                              <div>
                                <Img
                                  fluid={
                                    sessao.cimagemDaSessao.localFile
                                      .childImageSharp.fluid
                                  }
                                  alt={sessao.imagemDaSessao.altText}
                                />
                              </div>
                            ) : (
                              <div>
                                <img
                                  src={sessao.imagemDaSessao.sourceUrl}
                                  alt={sessao.imagemDaSessao.altText}
                                />
                              </div>
                            )}
                          </>
                        )
                      case '8':
                        return (
                          <>
                            <h2>{sessao.tituloDaSessao}</h2>
                            <VideoSlider videos={sessao.videos} />
                          </>
                        )
                      case '9':
                        return (
                          <>
                            <h2>{sessao.tituloDaSessao}</h2>
                          </>
                        )
                      default:
                        return null
                    }
                  })()}
                </div>
              </GroupContent>
            ))
          : ''}
      </Container>
    </>
  )
}

CustomPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const CustomPage = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const imageGatsby = page.opEsDaPGina.imagem.localFile
    ? page.opEsDaPGina.imagem.localFile
    : ''
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas, alturaImagemDestaque } = page.opEsDaPGina
  const { sessaoCustomizada } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <CustomPageTemplate
        title={page.title}
        content={page.content}
        imageGatsby={imageGatsby}
        image={image}
        alturaImagem={alturaImagemDestaque}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessaoCustomizada}
      />

      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

export default CustomPage

export const CustomPageQuery = graphql`
  query CustomPageById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          tituloDaSessao
          corDaSessao
          tipoDeConteudo
          texto
          imagemDaSessao {
            id
            sourceUrl
          }
          acordeao {
            conteudo
            titulo
          }
          links {
            tituloLink
            url
            descricao
          }
          linksExternos {
            titulo
            url
            data
            descricao
          }
          thumbList {
            titulo
            url
            data
            descricao
            imagemDestaque {
              sourceUrl
              localFile {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
          videos {
            embedId
            titulo
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        alturaImagemDestaque
        imagem {
          sourceUrl
          localFile {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
